import lightLogo from '../../../assets/img/softonic-admin-logo.png';
import darkLogo from '../../../assets/img/softonic-admin-logo.png';

export default function sftLogo(custom_style) {
    return( <>
        <img src={darkLogo} className='logoDarkClass' style={custom_style}/>
        <img src={lightLogo} className='logoClass' style={{filter: 'invert(1)', ...custom_style}}/>
    </>)
}
